(ns common.schema.entities.task-type
  (:require
   [common.util :as cu]))

(def task-types
  {:task.type/oceanio  {:translations {:en "Explorer task"}}
   :task.type/email    {:translations {:en "Email task"}}
   :task.type/webentry {:translations {:en "Webform task"}}
   :task.type/simple   {:translations {:en "Task"}}})

(def options
  (->> task-types
       (map (fn [[k meta]]
              {:key   k
               :label (->> meta
                           :translations
                           :en)}))
       (into [])))

(defn get-label
  [k]
  (->> options
       (cu/filter-by :key k)
       (first)
       :label))
